import React, { useEffect, useState, useRef } from 'react';

function Footer() {

    const [visible, setVisible] = useState(false);
    const footerRef = useRef(null);

    const handleScroll = () => {
        if (footerRef.current) {
            const footerTop = footerRef.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;

            // Show button when the footer is in view
            if (footerTop <= windowHeight) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scroll effect
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);




    return (
        <>

            <div>
                <footer className="footer" ref={footerRef}>
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-start align-items-center">
                                <div className="footer-logo mb-3 d-flex flex-nowrap align-items-center">
                                    <img className="me-5" src="/assets/images/iwmi-logo.png" alt="IWMI Logo" />
                                    <img className="me-5" src="/assets/images/cgiar-logo-white.webp" alt="CGIAR Logo" style={{ marginTop: '-10px', height: '80px' }} />
                                    <img className="me-5" src="/assets/images/helmsley-charitable-trust-logo-white.png" alt="Helmsley Logo" height={70} />
                                    <img src="/assets/images/AICCRA.jpg" alt="AICCRA Logo" style={{ marginTop: '-10px', height: '80px' }} />
                                </div>
                            </div>

                            {/* <div className="col-sm-12 col-md-2 col-lg-2 d-flex justify-content-center align-items-center">
                                <div className="footer-logo mb-3"> 
                                </div>
                            </div> */}
                            <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center">
                                <div className="contact-box mb-48px">
                                    <h6>FOLLOW US</h6>
                                    <ul className="social">
                                        <li>
                                            <a href="https://www.facebook.com/IWMIonFB" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/facebook.png" alt="facebook" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.flickr.com/photos/iwmi" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/flickr.png" alt="Flickr" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/iwmi_water/" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/instagram.png" alt="Instagram" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/company/iwmi" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/linkedin.png" alt="Linkedin" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.iwmi.org/rss-feeds/" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/rss.png" alt="RSS" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://x.com/IWMI_" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/twitter.png" alt="Twitter" height="16px" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.youtube.com/@iwmi" target="_blank" rel="noopener noreferrer">
                                                <img src="/assets/images/youtube.png" alt="Youtube" height="20px" className="mt-1" />
                                            </a>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="footer-logo">
                                <img src="/assets/images/footer-logo.svg" />
                            </div>
                            <div className="mt-25px">
                                <Breadcrumb>
                                    <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                                    <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
                                    <Breadcrumb.Item href="#">Blog</Breadcrumb.Item>
                                    <Breadcrumb.Item href="#">About Us</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Contact</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="contact-box mb-48px">
                                <h6>Contact Us</h6>
                                <h4>(+1 891 989-11-91)</h4>
                            </div>

                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="contact-box mb-48px">
                                        <h6>Location</h6>
                                        <p>2972 Westheimer Rd. Santa Ana,<br />
                                            Illinois 85486 </p>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="contact-box mb-48px">
                                        <h6>Email</h6>
                                        <p>hello@logoipsum.com</p> 
                                    </div>
                                </div>
                            </div>

                            <div className="contact-box mb-160px">
                                <h6>Mo—Fr</h6>
                                <h4>9am—6pm</h4>
                            </div>
                            <div className="contact-box">
                                <h6>© 2023 — Copyright</h6>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-sm-12 col-ld-12 col-lg-12">
                            <div className="footer-box">
                                <div className="contact-box d-flex justify-content-between align-items-center">
                                    <p className="mb-0 py-4 text-white"><NavLink className="text-white" to="">Explore<br />
                                        Dashboard</NavLink></p>
                                    <div>
                                        <NavLink to=""><img src="/assets/images/arrowUp.svg" /></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    </div>
                </footer>
                <div className="sub-footer">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <ul className="ps-0 d-flex text-white flex-wrap">
                                <li><a href="https://www.iwmi.org/copyright/" target="_blank">© 2025  International Water Management Institute (IWMI) </a></li> |
                                <li><a href="https://www.iwmi.org/terms-of-use/" target="_blank">Terms of use</a></li>
                            </ul>
                        </div>
                        <div>
                            <ul className="ps-0 d-flex text-white flex-wrap">
                                <li><a href="https://www.iwmi.org/contact/" target="_blank">Contact Us </a></li>
                                <li><a href="https://www.iwmi.org/subscribe/" target="_blank">Sign up for News</a></li>
                                <li><a href="https://www.iwmi.org/about/policies/#wbhotline" target="_blank">Whistleblower Hotline</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div>
                {visible && (
                    <span className="scroll-to-top" onClick={scrollToTop}>
                        <img src="/assets/images/to-top.svg" alt="Scroll to Top" />
                    </span>
                )}
            </div>

        </>
    )
}

export default Footer